import { DomainItem } from 'src/app/models/domain';
import { PortalActiveChoiceEnum } from 'src/app/shared/wizard/select-portal/select-portal.component';


export class CreateWebsiteInput {
  constructor(
    public portalName: string = '',
    public templateId: number = null,
    public portalTitle?: string,
    public domainId?: number
  ) {}
}

export class DomainsForUserResult {
  public renewalDate: number;
  public createdDate: number;
  public portalName: string;
  public status: string;
  public url: string;
}

export class GlobalWizardSettings {
  portalType: PortalActiveChoiceEnum;
  finalStepLabel: string;
  summaryAnimation: SummaryAnimationEnum;
  // nextButtonText?: string;
  // ideaAiCurrentState?: AiCurrentStateEnum
  // titleAiCurrentState?: AiCurrentStateEnum;
  // subtitleAiCurrentState?: AiCurrentStateEnum;
  // descriptionAiCurrentState?: AiCurrentStateEnum
}

export enum SummaryAnimationEnum {
  none = 'none',
  portal = 'portal',
}
export class GlobalWizardData {
  portalName?: string;
  templateId?: number;
  funnelId?: number;
  portalId?: number;
  domainId?: number;
  domain?: DomainItem;
  portalIdTemp?: number;
  portalTitle?: string;
}
